/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useRef, useState } from 'react';
//import './ChatBox.css';
import './ChatBoxDefault.css';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import LoadingPanel from '@/component/common/LoadingPanel';
import {
    buildListCategoriesMessage,
    buildListItemMessage,
    buildListTagFieldMessage,
    buildListTicketMessage,
    buildQueryForTagField,
    buildQueryForTagFieldWithSelectedItem,
    checkMessageOutOfSession,
    getListTicketAfterSelectedOption,
    getListTicketOfSelectedItem,
    getListTicketOfSelectedTagField,
    filterFieldHasNoTicketOption,
    buildFreeMessage,
    buildTheEndMessage,
    postMessage,
    createMessageList,
    sortListPreviousMessage,
    prepareDataForChatBotV2,
    buildLoadTagFiledMessage,
    buildQAFormMessage,
    getFormSystemQA,
    buildQAFormLiveChat,
    getCurrentTimeForMessage,
    anounymousEndLiveChat,
    onSubscriptionUpdateMessage,
    onSubscriptionDeleteMessage,
    getListTagFieldOfCategory,
    buildMessageSuggestUsingAI,
} from './handler/ChatBoxHandler';
import { useRecoilState } from 'recoil';
import { showChatBoxAtom } from '@/state/atom/showChatBoxAtom';
import { Storage } from 'aws-amplify';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { cloneDeep } from 'lodash';
import CollapseChatBox from './elements/CollapseChatBox';
import ExpandHeaderChatbox from './elements/ExpandHeaderChatbox';
import {
    updatePreviewCategoryListAtom,
    updatePreviewSettingAtom
} from '@/state/atom/chatBotPreview';
import ChatBotInput from './elements/ChatBotInput';
import ChatBotLiveChat from './elements/ChatBotLiveChat';
import ChatBotListMessage from './elements/ChatBotListMessage';
import { getRichTextFieldContent } from '@/component/ticketList/handler/TicketHandler';
import { v4 as uuidv4 } from 'uuid';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import {
    onSubscriptionAnonymousChatThread,
    onSubscriptionAnonymousChatThreadUpdatedMessage
} from './handler/SubscriptionHandler';
import MessageConnecting from './MessageConnecting';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { sendAiChatBotApi } from '@/service/chatAIService';
import { createKibanaInteractChatAI } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import IPRestrictionMessage from '@/component/publicPages/publicKnowledge/IPRestrictionMessage';
// import './knowledge-robo-default-style.css';

function ChatBox(props) {
    const { isModePreview, isIframeChatBot, API, deviceWidth, isPublicAccess } = props;
    const POPUlAR_MOBILE_DEVICE_WIDTH = 1024
    const supportThreadType = isIframeChatBot ? Constant.CHAT_BOT_ORIGIN.GEN_SCRIPT : '';
    const [listTagFieldOfSelectedCategory, setListTagFieldOfSelectedCategory] = useState([]);
    const [listTagFieldSelected, setListTagFieldSelected] = useState([]);
    const [listTagItemSelected, setListTagItemSelected] = useState([]);

    const [isEnableBtnSend, setIsEnableBtnSend] = useState(true);
    const [isEnableMsgInput, setIsEnableMsgInput] = useState(true);
    const [messages, setMessages] = useState([]);
    const [idOfResponseMessage, setIdOfResponseMessage] = useState('');
    const [isMaximizedPanel, setIsMaximizedPanel] = useState(false);
    const [filterPublicKnowledge, setFilterPublicKnowledge] = useState({
        viewId: '',
        tagFieldSelected: []
    });

    const [queryGetListKnowledgeBase, setQueryGetListKnowledgeBase] = useState({
        view: '',
        tagFieldSelected: []
    })

    const [listCategories, setListCategories] = useState([]);
    const [selectedOfOptions, setSelectedOptions] = useState({});
    const [listTagFieldId, setListTagFieldId] = useState([]);
    const [listKnowledgeTicketId, setListKnowledgeTicketId] = useState([]);
    const [listTicketIdBeforeFilterTagField, setListTicketIdBeforeFilterTagField] = useState([]);
    const [isShowChatBox, setIsShowChatBox] = useRecoilState(showChatBoxAtom);
    const [chatbotSettings, setChatBotSettings] = useState({});
    const messageRef = useRef();
    const [listOptionsAutocomplete, setListOptionsAutocomplete] = useState([]);
    const [supportThreadIdState, setSupportThreadId] = useState(
        localStorageUtil.getAnonymousSupportId(supportThreadType)
    );
    const [affiliationOrganization, setAffiliationOrganization] = useState('');
    const [affiliationProject, setAffiliationProject] = useState('');
    const [listSelectedItemOfSession, setListSelectedItemOfSession] = useState([]);
    const [previewSetting, setPreviewSetting] = useRecoilState(updatePreviewSettingAtom);
    const [previewCategoryList, setPreviewCategoryList] = useRecoilState(
        updatePreviewCategoryListAtom
    );
    const [maxNumberAnswer, setMaxNumberAnswer] = useState(1);
    const [useImageInAnswer, setUseImageAnswer] = useState(false);
    const [numberHitKnowledgeTicket, setNumberHitKnowledgeTicket] = useState(0);
    const [freeMessage, setFreeMessage] = useState('');
    const [projectAlias, setProjectAlias] = useState();
    const [categoryIdSelected, setCategoryIdSelected] = useState('');
    const [formQASystem, setFormQASystem] = useState({});
    const [isShowModalReload, setIsShowModalReload] = useState(false);
    const [actionWhenNotResolve, setActionWhenResolve] = useState(3);
    const [isActivateLiveChat, setIsActivateLiveChat] = useState(false);
    const [supportTicketId, setSupportTicketId] = useState(false);
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUploading, setFileUploading] = useState({});
    const [isShowModalEndChat, setIsShowModalEndChat] = useState(false);
    const [isShowMsgConnecting, setIsShowMsgConnecting] = useState(true);
    const [sentMessageList, setSentMessageList] = useState([]);
    const [listAgentData, setListAgentData] = useState([]);
    const [updatedMessage, setUpdatedMessage] = useState({});
    const [deletedMessage, setDeletedMessages] = useState({});
    const [isNewUnReadMessage, setIsNewUnReaMessage] = useState(false);
    const [projectInuseDetail,setProjectInuseDetail] = useState({});

    const [currentCorporationDetail,setCurrentCorporationDetail] = useState({});
    const [corporationDetail,setCorporationDetail] = useRecoilState(corporationAtom);
    const [isLoadingCss, setIsLoadingCss] = useState(false);
    const [enableListTicket,setEnableListTicket] = useState(false);
    const [listTagFieldSkip,setListTagFieldSkip] = useState([])

    const renderDefaultMessage = (listCategoriesOfProject, chatbotSetting, formQASystems = {}) => {
        let newMessage;
        if (listCategoriesOfProject?.length > 0) {
            newMessage = buildListCategoriesMessage(listCategoriesOfProject);
            // do not save first message when user the has not started the cha
            newMessage.isNotSaved = true;
        } else {
            if (!Utils.isEmptyObject(newMessage)) {
                return setMessages(prev => [...prev, newMessage]);
            }

            switch (chatbotSetting?.actionWhenNotResolve) {
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                    .CREATE_TICKET_AND_CHAT_WITH_AGENT:
                    let dataLiveChat = {
                        isDefault: true,
                        formQASystem: formQASystems
                    };
                    newMessage = buildQAFormLiveChat(dataLiveChat);
                    break;
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                    let data = {
                        isDefault: true,
                        data: {
                            formQASystem: formQASystems
                        }
                    };
                    newMessage = buildQAFormMessage(data, 'CBOTMSG011');
                    break;
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                default:
                    if (!Utils.isEmptyString(chatbotSetting.freeMsg)) {
                        const freeMessageContent = getRichTextFieldContent(chatbotSetting.freeMsg);
                        if (freeMessageContent) {
                            newMessage = buildFreeMessage(chatbotSetting.freeMsg);
                        }
                    }
                    break;
            }
        }
        if (!Utils.isEmptyArray(newMessage)) {
            setMessages(prev => [...prev, newMessage]);
        }
    };

    const renderDefaultMessagePreview = async (
        listCategoriesOfProject,
        chatbotSetting,
        formQASystems = {}
    ) => {
        let newMessage;
        if (listCategoriesOfProject?.length > 0) {
            newMessage = buildListCategoriesMessage(listCategoriesOfProject);
            // do not save first message when user the has not started the cha
            newMessage.isNotSaved = true;
            setMessages([newMessage]);
        } else {
            if (Utils.isEmptyObject(formQASystem)) {
                let formSystemQA = await getFormSystemQA(props.subDomain);
                setFormQASystem(formSystemQA);
            }
            switch (chatbotSetting?.actionWhenNotResolve) {
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                    .CREATE_TICKET_AND_CHAT_WITH_AGENT:
                    let dataLiveChat = {
                        isDefault: true,
                        formQASystem: formQASystems
                    };
                    newMessage = buildQAFormLiveChat(dataLiveChat);
                    setMessages([newMessage]);
                    break;

                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                    let data = {
                        isDefault: true,
                        data: {
                            formQASystem: formQASystems
                        }
                    };
                    newMessage = buildQAFormMessage(data, 'CBOTMSG011');
                    setMessages([newMessage]);
                    break;
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                default:
                    if (!Utils.isEmptyString(chatbotSetting.freeMsg)) {
                        const freeMessageContent = getRichTextFieldContent(chatbotSetting.freeMsg);
                        if (freeMessageContent) {
                            newMessage = buildFreeMessage(chatbotSetting.freeMsg);
                            setMessages([newMessage]);
                        }
                    }
                    break;
            }
        }
    };

    const renderPreviousMessage = (
        listPreviousMessage,
        listCategoriesOfProject,
        chatbotSetting
    ) => {
        let contentMessageList = sortListPreviousMessage(listPreviousMessage);
        const lastMessage = contentMessageList[contentMessageList.length - 1];

        if (lastMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FREE_MESSAGE) {
            let newMessage;

            if (listCategoriesOfProject.length > 0) {
                newMessage = buildListCategoriesMessage(listCategoriesOfProject);
                contentMessageList.push(newMessage);
            }
        }

        if (lastMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY) {
            let idOfCategory = lastMessage.idOfOption;

            const categoryDetail = listCategoriesOfProject?.find(category => {
                return category.id === idOfCategory;
            });

            if (Utils.isEmptyObject(categoryDetail)) {
                switch (chatbotSetting?.actionWhenNotResolve) {
                    case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                        .CREATE_TICKET_AND_CHAT_WITH_AGENT:
                        let idQALiveChat = `qaform_${uuidv4()}`;
                        let dataLiveChat = {
                            isDefault: true,
                            formQASystem: formQASystem,
                            idQA: idQALiveChat
                        };
                        let newFreeMessageQALiveChat = buildQAFormLiveChat(dataLiveChat);
                        contentMessageList.push(newFreeMessageQALiveChat);
                        break;

                    case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                        let idQA = `qaform_${uuidv4()}`;
                        let data = {
                            isDefault: true,
                            data: {
                                formQASystem: formQASystem
                            },
                            idQA: idQA
                        };
                        let newFreeMessageQA = buildQAFormMessage(data, 'CBOTMSG011');
                        contentMessageList.push(newFreeMessageQA);
                        break;

                    case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                    default:
                        let newFreeMessage = buildFreeMessage(chatbotSetting.freeMsg, 1);
                        contentMessageList.push(newFreeMessage);
                        if (listCategoriesOfProject.length > 0) {
                            const theEndMessage = buildTheEndMessage(2, formQASystem);
                            contentMessageList.push(theEndMessage);
                        }
                        break;
                }
            } else {
                const messageListTagFiled = buildLoadTagFiledMessage(idOfCategory, formQASystem, 1, usingAI, listTagFieldSelected, listTagItemSelected);

                contentMessageList.push(messageListTagFiled);
            }
        }

        if (lastMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.END_LIVE_CHAT) {
            const theEndMessage = buildTheEndMessage(1, formQASystem);
            postMessage(theEndMessage, supportTicketId, affiliationOrganization);
            contentMessageList.push(theEndMessage);
        }

        setMessages([...contentMessageList]);
    };

    const getCurrentStateOfSession = (listMessagePrevious,listCategoriesOfProject,corporationId,projectId) => {
        let contentMessageList = sortListPreviousMessage(listMessagePrevious);
        contentMessageList = contentMessageList.reverse()
        let latestSelectCategoryIndex = -1
        for (let index = 0; index < contentMessageList.length; index++) {
            const message = contentMessageList[index];
            if(message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY){
                latestSelectCategoryIndex = index
                break;
            }
            
        }

        let listMessageOfLastSession = contentMessageList.slice(0,latestSelectCategoryIndex+1)
        let idOfSelectedCategory = '';
        let listItemSelectedInSession = [];
        let listTagFieldSelectedInSession = [];
        let filterInfo = []
        let isEndSession = false;
        let listTagFiledIdOfSelectItem = [];
        for (let index = 0; index < listMessageOfLastSession.length; index++) {
            const message = listMessageOfLastSession[index];

            if(message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY){
                idOfSelectedCategory = message.idOfOption
            };

            if(message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_FIELD){
                if(!Utils.isEmptyArray(message.listTagItemSelected)){
                    listItemSelectedInSession = [...listItemSelectedInSession,...message.listTagItemSelected]
                };

                if(!Utils.isEmptyArray(message.listTagFieldSelected)){
                    listTagFieldSelectedInSession = [...listTagFieldSelectedInSession,...message.listTagFieldSelected]
                };

                listTagFieldSelectedInSession.push(message.idOfOption);
            }

            if(message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_ITEM){
                if(!Utils.isEmptyArray(message.listTagItemSelected)){
                    listItemSelectedInSession = [...listItemSelectedInSession,...message.listTagItemSelected]
                };

                if(!Utils.isEmptyArray(message.listTagFieldSelected)){
                    listTagFieldSelectedInSession = [...listTagFieldSelectedInSession,...message.listTagFieldSelected]
                };

                listItemSelectedInSession.push(message.idOfOption);
                listTagFiledIdOfSelectItem.push(message.idOfTagField)
                filterInfo.push({
                    idTagField: message.idOfTagField,
                    idTagItem: message.idOfOption
                });
            }

            if([Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.THE_END,Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FREE_MESSAGE].includes(message.messageType)){
                isEndSession = true
            }
            
        }

        if(!isEndSession && idOfSelectedCategory){
            listItemSelectedInSession = Utils.filterDuplicates(listItemSelectedInSession)
            listTagFieldSelectedInSession = Utils.filterDuplicates(listTagFieldSelectedInSession)
            setListTagFieldSelected([...listTagFieldSelectedInSession]);
            let listSkipTagField = listTagFieldSelectedInSession?.filter(id => !listTagFiledIdOfSelectItem.includes(id));
            setListTagFieldSkip([...listSkipTagField])
            setListTagItemSelected([...listItemSelectedInSession]);
            let tagFieldSelected = []
            filterInfo?.forEach(info => {
                let query = buildQueryForTagFieldWithSelectedItem(info.idTagField, info.idTagItem);
                let newFilter = {
                    bool: {
                        should: query
                    }
                };
                tagFieldSelected.push(newFilter);
            });

            const categorySelected = listCategoriesOfProject?.find(category => category.id === idOfSelectedCategory)
            const viewId = categorySelected?.chatBotCategorySetting?.viewId;
            setFilterPublicKnowledge({ viewId: viewId,
                tagFieldSelected: tagFieldSelected
             });
            setQueryGetListKnowledgeBase({ view: viewId,
                tagFieldSelected: tagFieldSelected
             });
             setCategoryIdSelected(idOfSelectedCategory)
             getListTagFieldOfCategory(projectId,props?.subDomain,corporationId,categorySelected,setListTagFieldOfSelectedCategory)
        }
    }

    const handlerWhenSelectedFormNoFound = (messageClone, newMessagesListParams) => {
        let settings = isModePreview ? previewSetting : chatbotSettings;

        switch (settings?.actionWhenNotResolve) {
            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE
                .CREATE_TICKET_AND_CHAT_WITH_AGENT:
                let idQALiveChat = `qaform_${uuidv4()}`;
                let dataLiveChat = {
                    isDefault: true,
                    formQASystem: formQASystem,
                    categoryIdSelected: categoryIdSelected,
                    idQA: idQALiveChat
                };
                let newFreeMessageQALiveChat = buildQAFormLiveChat(dataLiveChat);
                postMessage(
                    newFreeMessageQALiveChat,
                    supportThreadIdState,
                    affiliationOrganization,
                    false,
                    isModePreview,
                    idQALiveChat
                );
                setMessages(pev => [...pev, newFreeMessageQALiveChat]);
                break;

            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                let idQA = `qaform_${uuidv4()}`;
                let data = {
                    isDefault: false,
                    idQA: idQA,
                    data: {
                        categoryIdSelected: categoryIdSelected,
                        formQASystem: formQASystem
                    }
                };
                const newMessage = buildQAFormMessage(data);
                postMessage(
                    newMessage,
                    supportThreadIdState,
                    affiliationOrganization,
                    false,
                    isModePreview,
                    idQA
                );
                setMessages(pev => [...pev, newMessage]);
                break;

            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
            default:
                let newMessagesList = !Utils.isEmptyArray(newMessagesListParams)
                    ? newMessagesListParams
                    : [];
                newMessagesList.push(buildFreeMessage(freeMessage, newMessagesList.length));

                if (!Utils.isEmptyArray(listCategories)) {
                    newMessagesList.push(buildTheEndMessage(newMessagesList.length, formQASystem));
                }
                createMessageList(
                    newMessagesList,
                    supportThreadIdState,
                    affiliationOrganization,
                    isModePreview
                );
                setMessages([...messageClone, ...newMessagesList]);
                break;
        }
        return;
    };

    useEffect(() => {
        if (!isModePreview) {
            setProjectAlias(props.projectId);
            prepareDataForChatBotV2(
                props.projectId,
                props.subDomain,
                isModePreview,
                supportThreadType
            ).then(async response => {
                let affiliationOrganizationDetail = response.affiliationOrganizationDetail;
                affiliationOrganizationDetail.name = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,affiliationOrganizationDetail?.name)
                setCurrentCorporationDetail(affiliationOrganizationDetail)
                let affiliationProjectDetail = response.affiliationProjectDetail;
                affiliationProjectDetail.name = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP,affiliationProjectDetail?.name)
                setProjectInuseDetail(affiliationProjectDetail)
                console.log('response :>>--------------------- ', response);
                let {
                    chatbotSetting,
                    isCreateNewSupportThread,
                    newThreadSupport,
                    projectId,
                    corporationId
                } = response;
                let listCategoriesOfProject = Utils.isEmptyArray(response?.listCategoriesProject)
                    ? []
                    : response?.listCategoriesProject;
                let formQASystems = Utils.isEmptyObject(response?.formQASystem)
                    ? {}
                    : response?.formQASystem;
                listCategoriesOfProject = Utils.sortCategoriesByOrder(
                    cloneDeep(listCategoriesOfProject)
                );

                setSupportTicketId(response.ticketId);

                setIsActivateLiveChat(
                    !Utils.isEmptyString(response.ticketId) &&
                        response.ticketId.includes(Constant.TICKET_PREFIX.REQ)
                );

                if (!Utils.isEmptyArray(response.listAgentData)) {
                    setListAgentData(response.listAgentData);
                }
                let listPreviousMessage = response?.chatPostList;
                listPreviousMessage = listPreviousMessage?.filter(message => {
                    return message.postType !== Constant.POST_TYPE.ANONYMOUS_END_LIVE_CHAT;
                });
                let enableListTicketSetting = chatbotSetting?.hasOwnProperty('enableListTicket') ? chatbotSetting.enableListTicket : true
                setEnableListTicket(enableListTicketSetting)
                //check setting max num of answer
                if (!chatbotSetting.maxNumberAnswer) {
                    chatbotSetting.maxNumberAnswer = 5;
                }

                if (!Utils.isEmptyObject(chatbotSetting)) {
                    const [logoIcon, headerIcon, sendIcon] = await Promise.all([
                        getLogoHeader(chatbotSetting?.logo),
                        getLogoHeader(chatbotSetting?.headerIcon),
                        getLogoHeader(chatbotSetting?.sendIcon)
                    ]);

                    chatbotSetting.logo = logoIcon
                    chatbotSetting.headerIcon = headerIcon
                    chatbotSetting.sendIcon = sendIcon
                }

                //enable chatbot
                if (chatbotSetting.isActivateChatbot) {
                    props.setIsEnableChatBox(true);
                }

                if (chatbotSetting.numberHitKnowledgeTicket) {
                    setNumberHitKnowledgeTicket(chatbotSetting.numberHitKnowledgeTicket);
                } else {
                    setNumberHitKnowledgeTicket(5);
                }
                setUseImageAnswer(chatbotSetting.useImageInAnswer);
                setFreeMessage(chatbotSetting.freeMsg);
                setAffiliationOrganization(corporationId);
                setAffiliationProject(projectId);
                setListCategories(listCategoriesOfProject);
                setChatBotSettings(chatbotSetting);
                setFormQASystem(formQASystems);
                setActionWhenResolve(chatbotSetting.actionWhenNotResolve);

                //set support thread to local storage
                let clientThreadSupport = localStorageUtil.getAnonymousSupportId(supportThreadType);
                if (isCreateNewSupportThread && !Utils.isEmptyString(newThreadSupport)) {
                    clientThreadSupport = Utils.isEmptyObject(
                        localStorageUtil.getAnonymousSupportId(supportThreadType)
                    )
                        ? {}
                        : clientThreadSupport;
                    clientThreadSupport[projectId] = newThreadSupport;
                    setSupportThreadId(newThreadSupport);
                    localStorageUtil.setAnonymousSupportId(clientThreadSupport, supportThreadType);
                } else {
                    setSupportThreadId(clientThreadSupport[projectId]);
                }

                //subscription chat post
                onSubscriptionAnonymousChatThread(clientThreadSupport[projectId], {
                    messages: messages,
                    setMessages: setMessages,
                    setIsActivateLiveChat,
                    listAgentData: Utils.isEmptyArray(response.listAgentData)
                        ? []
                        : response.listAgentData,
                    setListAgentData: setListAgentData,
                    projectId: projectId,
                    corporationId: corporationId,
                    formQASystems: formQASystems,
                    setIsOpenModalReloadPage: setIsShowModalReload,
                    setIsNewUnReaMessage: setIsNewUnReaMessage
                });
                onSubscriptionAnonymousChatThreadUpdatedMessage(clientThreadSupport[projectId], {
                    setUpdatedMessage: setUpdatedMessage
                });

                if (isCreateNewSupportThread || listPreviousMessage.length === 0) {
                    renderDefaultMessage(
                        listCategoriesOfProject,
                        chatbotSetting,
                        formQASystems,
                        newThreadSupport,
                        corporationId
                    );
                } else {
                    renderPreviousMessage(
                        listPreviousMessage,
                        listCategoriesOfProject,
                        chatbotSetting
                    );
                    getCurrentStateOfSession(listPreviousMessage,listCategoriesOfProject,corporationId,projectId)
                }

                let existedKnowledgeRoboCss = document.getElementById('knowledge-robo-css');
                if (!existedKnowledgeRoboCss) {
                    const versionCss = chatbotSetting?.versionKnowledgeRoboStyleCss
                    const keyFile = Utils.genKeyFileCss(corporationId, projectId, versionCss, Constant.KEY_FILE_CSS_TYPE.KNOWLEDGE_ROBO);
                    let linkS3 = ''
                    if (!keyFile) {
                        linkS3 =`${process.env.REACT_APP_CLOUD_FRONT_URL}/public/assets/knowledge-robo-default-style.css`;
                    } else {
                        linkS3 = `${process.env.REACT_APP_CLOUD_FRONT_URL}/public/${keyFile}`;
                    }
                    const linkElement = document.createElement("link");
                    linkElement.setAttribute("rel", "stylesheet");
                    linkElement.setAttribute("type", "text/css");
                    linkElement.setAttribute("id", "knowledge-robo-css");
                    linkElement.setAttribute(
                        "href",
                        linkS3
                    );
                    document.head.appendChild(linkElement);
                    setIsLoadingCss(true)
                }


                if (isIframeChatBot)
                    window.parent.postMessage(Constant.CHATBOT_ACTION.FINISHED_RENDER_CHATBOT, '*');
            });
        }
    }, [props.projectId]);

    useEffect(() => {
        if (!Utils.isEmptyObject(updatedMessage)) {
            const updatedMessageClone = cloneDeep(updatedMessage);
            if (updatedMessageClone.status === 4) {
                onSubscriptionDeleteMessage(messages, setMessages, updatedMessageClone);
            } else {
                onSubscriptionUpdateMessage(messages, setMessages, updatedMessageClone);
            }
        }
    }, [updatedMessage]);

    useEffect(() => {
        if (!Utils.isEmptyObject(deletedMessage)) {
            const deletedMessageClone = cloneDeep(deletedMessage);
            onSubscriptionDeleteMessage(messages, setMessages, deletedMessageClone);
        }
    }, [deletedMessage]);

    useEffect(() => {
        if (isModePreview) {
            setAffiliationOrganization(localStorageUtil.getAffiliationOrganization());
            setAffiliationProject(localStorageUtil.getSelectedProjectId());

            if (previewSetting.freeMsg !== freeMessage) {
                setFreeMessage(previewSetting.freeMsg);
            }

            if (previewSetting.numberHitKnowledgeTicket !== numberHitKnowledgeTicket) {
                setNumberHitKnowledgeTicket(previewSetting.numberHitKnowledgeTicket);
            }

            if (previewSetting.maxNumberAnswer !== maxNumberAnswer) {
                setMaxNumberAnswer(previewSetting.maxNumberAnswer);
            }

            if (previewSetting.useImageInAnswer !== useImageInAnswer) {
                setUseImageAnswer(previewSetting.useImageInAnswer);
            }

            if (previewSetting.projectAlias !== projectAlias) {
                setProjectAlias(previewSetting.projectAlias);
            }

            if (previewSetting.actionWhenNotResolve !== actionWhenNotResolve) {
                setActionWhenResolve(previewSetting.actionWhenNotResolve);
            }
            
            if(previewSetting.enableListTicket !== enableListTicket){
                setEnableListTicket(previewSetting.enableListTicket)
            }
        }
    }, [previewSetting]);

    useEffect(() => {
        (async () => {
            if (isModePreview) {
                let formSystemQA = await getFormSystemQA(props.subDomain);
                setFormQASystem(formSystemQA);
            }
        })();
    }, [props.subDomain]);

    useEffect(() => {
        let isMounted = true;
        if (isMounted && isModePreview) {
            let newListCategories = Utils.isEmptyArray(previewCategoryList)
                ? []
                : [...previewCategoryList];
            if (newListCategories?.length > 0) {
                newListCategories = Utils.sortCategoriesByOrder(cloneDeep(previewCategoryList));
            }
            setListCategories([...newListCategories]);
        }

        return () => {
            isMounted = false;
        }
    }, [previewCategoryList]);

    useEffect(() => {
        let isMounted = true;
        if (isMounted && isModePreview) {
            clearSession();
            let newListCategories = Utils.isEmptyArray(previewCategoryList)
                ? []
                : [...previewCategoryList];
            if (newListCategories?.length > 0) {
                newListCategories = Utils.sortCategoriesByOrder(cloneDeep(previewCategoryList));
            }
            renderDefaultMessagePreview(newListCategories, previewSetting, formQASystem);
            setIsActivateLiveChat(false);
        }

        return () => {
            isMounted = false;
        }
    }, [
        freeMessage,
        numberHitKnowledgeTicket,
        listCategories,
        maxNumberAnswer,
        useImageInAnswer,
        actionWhenNotResolve,
        formQASystem
    ]);

    const scrollIntoViewMsg = () => {
        setTimeout(() => {
            // if (!isModePreview)  messageRef?.current?.scrollIntoView({ behavior: 'smooth' });
            const element = document.getElementById(`chatbot-msgbox`);
            if (element) {
                let scrollHeight = element?.scrollHeight - element?.clientHeight
                // console.log('namnhdebug scroll 3', scrollHeight)
                element.scrollTop = scrollHeight;
            }
           
        }, 200);
    };

    const clearSession = () => {
        setMessages([]);
        setListTagFieldSelected([]);
        setListTagItemSelected([]);
        setListKnowledgeTicketId([]);
        setListTicketIdBeforeFilterTagField([]);
        setFilterPublicKnowledge({
            viewId: '',
            tagFieldSelected: []
        });
        setQueryGetListKnowledgeBase({
            viewId: '',
            tagFieldSelected: []
        });
    };

    const scrollIntoViewList = () => {
        setTimeout(() => {
            // console.log('namnhdebug scroll 4')
            // if (!isModePreview) messageRef?.current?.scrollIntoView({ behavior: 'auto' });
            let idDivContentList = `chatbot-msgbox`;
            const element = document.getElementById(idDivContentList);
            if (element) {
                element.scrollTop = element.scrollHeight;
            }
           
        }, 200);
    };

    useEffect(() => {
        let lastMessage = messages[messages.length - 1];
        switch (lastMessage?.messageType) {
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_FORM:
                setListOptionsAutocomplete(lastMessage?.content);
                break;
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_FIELD:
                setListOptionsAutocomplete(lastMessage?.content);
                break;
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_ITEM:
                setListOptionsAutocomplete(lastMessage?.content);
                break;
            default:
                setListOptionsAutocomplete([]);
                break;
        }
        scrollIntoViewMsg();
    }, [messages]);

    useEffect(() => {
        if (!isModePreview) scrollIntoViewList();
    }, [isShowChatBox]);

    //check
    const handleClickFormOption = (selectedOption, idOfMessage) => {
        // validate message
        if (checkMessageOutOfSession(messages, idOfMessage)) return;
        setListTagFieldSkip([]);
        setCategoryIdSelected(selectedOption.id);
        //update selected tag field for next session;
        setListTagFieldSelected([]);
        setListTagItemSelected([]);
        setListKnowledgeTicketId([]);
        let { id, name } = selectedOption;
        let messageClone = cloneDeep([...messages]);

        // save first message when user start chat thread;
        let messageListForm = messageClone[messageClone.length - 1];
        if (messageListForm.isNotSaved) {
            postMessage(
                messageListForm,
                supportThreadIdState,
                affiliationOrganization,
                true,
                isModePreview
            );
            messageListForm.isNotSaved = false;
            messageClone[messageClone.length - 1] = messageListForm;
        }

        let newIdMessage = getCurrentTimeForMessage();
        let newMessagesList = [
            {
                content: name,
                isFromMe: true,
                idMessage: newIdMessage,
                idOfOption: id,
                noInFrame: 0,
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY,
                listTagFieldSelected: [],
                listTagItemSelected: [],
            }
        ];

        messageClone = [...messageClone, ...newMessagesList];

        //get list tag field used of category
        const categoryDetail = listCategories?.find(category => {
            return category.id === id;
        });

        if (Utils.isEmptyObject(categoryDetail)) {
            handlerWhenSelectedFormNoFound(messageClone, newMessagesList);
            return;
        }

        setFilterPublicKnowledge({
            view: Utils.isEmptyString(categoryDetail?.chatBotCategorySetting?.viewId)
                ? ''
                : categoryDetail.chatBotCategorySetting.viewId,
            tagFieldSelected: []
        });

        setQueryGetListKnowledgeBase({
            view: Utils.isEmptyString(categoryDetail?.chatBotCategorySetting?.viewId)
                ? ''
                : categoryDetail.chatBotCategorySetting.viewId,
            tagFieldSelected: []
        })

        const messageListTagFiled = buildLoadTagFiledMessage(id, formQASystem, 1, usingAI, listTagFieldSelected, listTagItemSelected);
        messageClone.push(messageListTagFiled);

        createMessageList(
            [...newMessagesList],
            supportThreadIdState,
            affiliationOrganization,
            isModePreview,
            selectedOption,
            affiliationProject,
            projectInuseDetail,
            currentCorporationDetail,
            categoryIdSelected
        );
        setMessages([...messageClone]);

        scrollIntoViewMsg();
    };

    //check
    // click tag field
    const handleClickFieldOption = (selectedOption, idOfMessage) => {
        let { id, name } = selectedOption;
        if (checkMessageOutOfSession(messages, idOfMessage)) return;

        if (!listTagFieldSelected.includes(id)) {
            setListTagFieldSelected(pev => [...pev, id]);
        }

        let newListTagFieldSelected = [...listTagFieldSelected, id];
        
        const categoryDetail = listCategories?.find(category => {
            return category.id === categoryIdSelected;
        });
        let newIdMessage = getCurrentTimeForMessage();
        let newMessagesList = [
            {
                content: name,
                isFromMe: true,
                idMessage: newIdMessage,
                idOfOption: id,
                noInFrame: 0,
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_FIELD,
                categoryName: categoryDetail?.name?.jp?.text,
                listTagFieldSelected: newListTagFieldSelected,
                listTagItemSelected
            }
        ];

        const fieldDetail = listTagFieldOfSelectedCategory?.find(tagField => {
            return tagField.id === id;
        });
        
        if (Utils.isEmptyObject(fieldDetail)) {
            handlerWhenSelectedFormNoFound(messages);
            return;
        }

        const listTicketIdOfField = getListTicketOfSelectedTagField(fieldDetail);
        setListTicketIdBeforeFilterTagField([...listKnowledgeTicketId]);

        const listTicketAfterSelectedField = getListTicketAfterSelectedOption(
            listKnowledgeTicketId,
            listTicketIdOfField
        );
        setListKnowledgeTicketId([...listTicketAfterSelectedField]);
        // let filter = buildQueryForTagField(fieldDetail);
        // let filterObjectClone = { ...filterPublicKnowledge };

        // filterObjectClone.tagFieldSelected.push(filter);
        // setQueryGetListKnowledgeBase(filterObjectClone);

        let selectedFieldItem = filterListItemOfSelectedTagField(
            listTicketAfterSelectedField,
            fieldDetail.ticketItemData,
            fieldDetail.child
        );
        newMessagesList.push(
            buildListItemMessage(id, selectedFieldItem, newMessagesList.length, name, null, usingAI, [...newListTagFieldSelected], listTagItemSelected)
        );

        createMessageList(
            newMessagesList,
            supportThreadIdState,
            affiliationOrganization,
            isModePreview,
            selectedOption,
            affiliationProject,
            projectInuseDetail,
            currentCorporationDetail,
            categoryIdSelected
        );
        setMessages([...messages, ...newMessagesList]);

        // if (listTicketAfterSelectedField.length <= numberHitKnowledgeTicket) {    
        //     setFilterPublicKnowledge(filterObjectClone);
        //     newMessagesList.push(
        //         buildListTicketMessage(
        //             filterObjectClone.tagFieldSelected,
        //             newMessagesList.length,
        //             listSelectedItemOfSession
        //         )
        //     );
        //     createMessageList(
        //         newMessagesList,
        //         supportThreadIdState,
        //         affiliationOrganization,
        //         isModePreview,
        //         selectedOption,
        //         affiliationProject,
        //         projectInuseDetail,
        //         currentCorporationDetail,
        //         categoryIdSelected
        //     );
        //     setMessages([...messages, ...newMessagesList]);
        // } else {
        //     let selectedFieldItem = filterListItemOfSelectedTagField(
        //         listTicketAfterSelectedField,
        //         fieldDetail.ticketItemData,
        //         fieldDetail.child
        //     );
        //     newMessagesList.push(
        //         buildListItemMessage(id, selectedFieldItem, newMessagesList.length, name, null, usingAI)
        //     );

        //     createMessageList(
        //         newMessagesList,
        //         supportThreadIdState,
        //         affiliationOrganization,
        //         isModePreview,
        //         selectedOption,
        //         affiliationProject,
        //         projectInuseDetail,
        //         currentCorporationDetail,
        //         categoryIdSelected
        //     );
        //     setMessages([...messages, ...newMessagesList]);
        // }
    };

    const filterListItemOfSelectedTagField = (listTicketId, ticketItemData, itemList, listTagItemSelectedNow = []) => {
        let listItemValid = [];
        let listItemValidId = [];
        itemList.forEach(item => {  
            if (![...listTagItemSelected, ...listTagItemSelectedNow].includes(item?.id)) {
                listTicketId.forEach(ticketId => {
                    let listItemOfTicket = ticketItemData[ticketId];
                    if (listItemOfTicket?.includes(item.id)) {
                        if (!listItemValidId.includes(item.id)) {
                            listItemValid.push(item);
                            listItemValidId.push(item.id);
                        }
                    }
                });
            }
        });

        return listItemValid;
    };

    //check
    // click tag item
    const handleClickItemOption = async (selectedOfOption, idOfMessage) => {
        
        if (checkMessageOutOfSession(messages, idOfMessage)) return;
        const categoryDetail = listCategories?.find(category => {
            return category.id === categoryIdSelected;
        });

        let { id, idOfTagField, name } = selectedOfOption;

        const fieldDetail = listTagFieldOfSelectedCategory?.find(tagField => {
            return tagField.id === idOfTagField;
        });

        let newIdMessage = getCurrentTimeForMessage();
        let newMessagesList = [
            {
                content: name,
                isFromMe: true,
                idMessage: newIdMessage,
                idOfOption: id,
                noInFrame: 0,
                idOfTagField: idOfTagField,
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_ITEM,
                nameCategory: categoryDetail?.name?.jp?.text,
                nameOfTagField: fieldDetail?.label,
                listTagFieldSelected,
                listTagItemSelected
            }
        ];

        let listSelectedItemOfSessionClone = [...listSelectedItemOfSession, { [idOfTagField]: id }];
        setListSelectedItemOfSession(pev => [...pev, { [idOfTagField]: id }]);

        let filterObjectClone = { ...filterPublicKnowledge };
        let query = buildQueryForTagFieldWithSelectedItem(idOfTagField, id);
        let newFilter = {
            bool: {
                should: query
            }
        };
        
        filterObjectClone.tagFieldSelected.push(newFilter);
        setFilterPublicKnowledge({ ...filterObjectClone });
        setQueryGetListKnowledgeBase({...filterObjectClone});

        if (Utils.isEmptyObject(fieldDetail)) {
            handlerWhenSelectedFormNoFound(newMessagesList);
            return;
        }

        if (!listTagFieldSelected.includes(idOfTagField)) {
            setListTagFieldSelected(prev => [...prev, idOfTagField]);
        }

        if (!listTagItemSelected.includes(id)) {
            setListTagItemSelected(pev => [...pev, id]);
        }

        let listTicketIdOfItem = getListTicketOfSelectedItem(fieldDetail, id);
        const listTicketAfterSelectedItem = getListTicketAfterSelectedOption(
            listKnowledgeTicketId,
            listTicketIdOfItem
        );

        setListKnowledgeTicketId([...listTicketAfterSelectedItem]);
        let lastMessage = messages[messages.length - 1];
        let listTagItemSelectedInDB = [];
        if (lastMessage && !Utils.isEmptyObject(lastMessage) && lastMessage?.listTagItemSelected && !Utils.isEmptyArray(lastMessage?.listTagItemSelected)) {
            listTagItemSelectedInDB = [...lastMessage?.listTagItemSelected];
        }

        let listFieldValid = filterFieldHasNoTicketOption(
            listTagFieldOfSelectedCategory,
            listTicketAfterSelectedItem,
            listTagFieldSelected,
            [...listTagItemSelectedInDB, ...listTagItemSelected, id]
        );
        
        let newMessage = {};
        if (
            (listTicketAfterSelectedItem.length <= numberHitKnowledgeTicket && enableListTicket) ||
            listFieldValid.length === 0
        ) {
            newMessage = enableListTicket ? buildListTicketMessage(
                filterObjectClone.tagFieldSelected,
                newMessagesList.length,
                listSelectedItemOfSessionClone,
                usingAI
            ) : buildMessageSuggestUsingAI(newMessagesList.length)
            newMessagesList.push(newMessage);
        } else {
            // const listTagFieldForNewMessage = listFieldValid.filter(tagFiled => {
            //     return !listTagFieldSelected.includes(tagFiled.id) && tagFiled.id !== idOfTagField;
            // });
            
            const listTagFieldForNewMessage = listFieldValid?.filter(tagField => !listTagFieldSkip.includes(tagField.id))

            if (listTagFieldForNewMessage.length === 0) {
                newMessage = enableListTicket ? buildListTicketMessage(
                    filterObjectClone.tagFieldSelected,
                    newMessagesList.length,
                    listSelectedItemOfSessionClone,
                    usingAI
                ) : buildMessageSuggestUsingAI(newMessagesList.length)
                newMessagesList.push(newMessage);
            }

            if (listTagFieldForNewMessage[0]?.priority || listTagFieldForNewMessage?.length === 1) {
                
                const listTicketIdOfField = getListTicketOfSelectedTagField(
                    listTagFieldForNewMessage[0]
                );
                setListTicketIdBeforeFilterTagField([...listTicketAfterSelectedItem]);

                const listTicketAfterSelectedField = getListTicketAfterSelectedOption(
                    listTicketAfterSelectedItem,
                    listTicketIdOfField
                );

                if (listTicketAfterSelectedField.length === 0) {
                    newMessage = enableListTicket ? buildListTicketMessage(
                        filterObjectClone.tagFieldSelected,
                        newMessagesList.length,
                        listSelectedItemOfSessionClone,
                        usingAI
                    ) : buildMessageSuggestUsingAI(newMessagesList.length)
                    newMessagesList.push(newMessage);
                } else {
                    
                    setListTagFieldSelected(prev => [...prev, listTagFieldForNewMessage[0].id]);
                    newMessage = handleWhenRenderTagFieldPriority(
                        listTagFieldForNewMessage[0],
                        listTicketAfterSelectedField,
                        false,
                        [...listTagItemSelectedInDB, ...listTagItemSelected, id]
                    );
                    newMessagesList.push(newMessage);
                }
            }

            if (
                !listTagFieldForNewMessage[0]?.priority &&
                listTagFieldForNewMessage.length > 1
            ) {
                
                newMessage = buildListTagFieldMessage(
                    listTagFieldForNewMessage,
                    listTagFieldSelected,
                    1,
                    false,
                    usingAI,
                    listTagFieldSelected,
                    [...listTagItemSelected, id]
                );
                newMessagesList.push(newMessage);
            }
        }
        createMessageList(
            newMessagesList,
            supportThreadIdState,
            affiliationOrganization,
            isModePreview,
            selectedOfOption,
            affiliationProject,
            projectInuseDetail,
            currentCorporationDetail,
            categoryIdSelected
        );
        setMessages([...messages, ...newMessagesList]);
    };
    const getLogoHeader = async keyLogo => {
        if (Utils.isEmptyObject(keyLogo)) return;

        if (keyLogo === Constant.CHATBOT_DEFAULT || keyLogo === Constant.SETTING_CHAT_BOT.SEND_LOGO) {
            return keyLogo;
        }

        let keyFile = `/public/${keyLogo}`;

        let logo = Utils.getCloudFrontUrlOfFilePublicAll(keyFile);
        if (logo) return logo;

        logo = await Storage.get(keyLogo, { level: 'public' });
        return logo;
    };

    const onChangeOptionsAutocomplete = (_, value) => {
        if (!value.id) {
            return false;
        }
        let lastMessage = messages[messages.length - 1];
        switch (lastMessage.messageType) {
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_FORM:
                handleClickFormOption(value, lastMessage?.idMessage);
                break;
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_FIELD:
                handleClickFieldOption(value, lastMessage?.idMessage);
                break;
            case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_ITEM:
                handleClickItemOption(value, lastMessage?.idMessage);
                break;
            default:
                break;
        }
        setSelectedOptions({});
    };

    const onSubmitSendMessage = async (value) => {
        if (Utils.isEmptyString(value) && !isEnableBtnSend) { return false }
        
        let newMessagesList = [];
        let newIdMessage = getCurrentTimeForMessage();
        let messageClone = cloneDeep([...messages]);

        if (isModePreview) {
            newMessagesList = [
                {
                    content: value,
                    isFromMe: true,
                    idMessage: newIdMessage,
                    noInFrame: 0,
                    messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.USER_SEND_CHAT_AI
                },
                {
                    isFromMe: false,
                    isLoadingMessage: false,
                    idMessage: newIdMessage,
                    content: I18n.get('MSG-AI-RESPOND-TO-USER-MSG-ON-PREVIEW-KNOW-ROBO')
                }
            ];
            setMessages([...messageClone, ...newMessagesList]);
            return false;
        }

        newMessagesList = [
            {
                content: value,
                isFromMe: true,
                idMessage: newIdMessage,
                noInFrame: 0,
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.USER_SEND_CHAT_AI
            },
            {
                isFromMe: false,
                isLoadingMessage: true,
                idMessage: newIdMessage,
                messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.GPT_RESPONSE_MESSAGE
            }
        ];
        
        let chatPostId = uuidv4();

        setMessages([...messageClone, ...newMessagesList]);
        setIdOfResponseMessage(chatPostId);
        scrollIntoViewMsg();
        setIsEnableBtnSend(false);
        let paramsKnowledgeBase = {
            view: queryGetListKnowledgeBase?.view,
            tagFieldQuery: queryGetListKnowledgeBase?.tagFieldSelected
        }

        const categoryDetail = listCategories.find(category => {
            return category.id === categoryIdSelected;
        });

        const viewStructure = categoryDetail.viewStructure;

        try {
            let requestDto = {
                corporationId: currentCorporationDetail.id,
                projectId: projectInuseDetail.id,
                currentUserId: 'anonymous',
                chatThreadId: supportThreadIdState,
                message: value,
                queryGetListKnowledgeBase: JSON.stringify(paramsKnowledgeBase),
                projectInuseType: 'PRJ_GENERAL',
                ticketIdList: [],
                ticketProperty: 'SENT',
                from: 0,
                size: 30,
                chatPostId: chatPostId,
                formQASystem: JSON.stringify(formQASystem),
                categoryIdSelected: categoryIdSelected,
                structure: JSON.stringify(viewStructure)
            }
            const basicPromptInSettingChatbot = chatbotSettings?.basicPrompt ? chatbotSettings?.basicPrompt : ""
            const basicPromptID = Utils.destructLinkPrompt(basicPromptInSettingChatbot)
            const lastedTagGroupId = listTagFieldSelected.length > 0 ? listTagFieldSelected[listTagFieldSelected.length - 1] : ""
            const tagGroupKeyValue = lastedTagGroupId ? { [lastedTagGroupId]: lastedTagGroupId } : {}

            const dataLog = {
                corporationDetail: {}, // pks this's not existed
                projectDetail: {},
                userDetail: {},
                rootProjectDetail: projectInuseDetail,
                rootCorporationDetailId: currentCorporationDetail?.id,
                tabNameChatAI: '',
                aiChatInquiryText: value,
                basicPromptID: basicPromptID,
                userSelectedPrompt: [],
                projectIdKnowledgeSelected: '',
                hitNumber: numberHitKnowledgeTicket,
                qaCategoryId: categoryIdSelected,
                tagFieldsSelected: [tagGroupKeyValue, ...listSelectedItemOfSession] // first item is always lasted tag group, another items is tag items.
            }

            const logKibanaData = createKibanaInteractChatAI(dataLog, LogKibanaConstant.AI_CHAT_SCREEN.ROBO);
            requestDto = {
                ...requestDto,
                logKibanaData: JSON.stringify(logKibanaData)
            };

            await sendAiChatBotApi(requestDto,setMessages,getCurrentTimeForMessage);

        } catch (error) {
            console.error("Component ChatBox ~ sendAiChatBotApi", error);

            if (Array.isArray(messages) && messages.length > 0) {
                let errorMessage = {
                    isFromMe: false,
                    content: I18n.get('MSG-PROCESSING-TIME-EXCEEDED'),
                    isError: true
                };
                setMessages([...messages, errorMessage]);
            }
        }
    }

    const handleWhenRenderTagFieldPriority = (
        fieldDetail,
        listTicketAfterSelectedField,
        isDisplayBackBtnInItemMessage = false,
        listTagItemSelectedNow
    ) => {
        setListKnowledgeTicketId([...listTicketAfterSelectedField]);
        let newMessage = {};

        // let filter = buildQueryForTagField(fieldDetail);
        // let filterObjectClone = { ...filterPublicKnowledge };
        // filterObjectClone.tagFieldSelected.push(filter);
        // setQueryGetListKnowledgeBase(filterObjectClone);

        let selectedFieldItem = filterListItemOfSelectedTagField(
            listTicketAfterSelectedField,
            fieldDetail.ticketItemData,
            fieldDetail.child,
            listTagItemSelectedNow
        );
        newMessage = buildListItemMessage(
            fieldDetail.id,
            selectedFieldItem,
            1,
            fieldDetail.label,
            isDisplayBackBtnInItemMessage,
            usingAI,
            listTagFieldSelected,
            listTagItemSelectedNow
        );

        return newMessage;
    };

    function hasScrollbar() {
        return document.documentElement.scrollHeight > document.documentElement.clientHeight;
    }

    const callUpdatedEndChat = async () => {
        setIsShowModalEndChat(false);
        setIsShowMsgConnecting(false);

        setIsActivateLiveChat(false);
        const backToBeginMessage = buildTheEndMessage(1, formQASystem);
        setMessages(pev => [...pev, backToBeginMessage]);
        postMessage(backToBeginMessage, supportThreadIdState, affiliationOrganization);

        //Call API update after user end chat
        await anounymousEndLiveChat(supportTicketId);
    };

    const isShowChatBot = () => {
        if (isModePreview) {
            return (corporationDetail?.limitValue?.knowledgeBot === 1);
        }
        return (currentCorporationDetail?.isKnowledgeBotOn === 1);
    }
    const usingAI = props?.publicKnowledgeSetting?.usingAI || props?.usingAI;

    if (!isLoadingCss && !isModePreview) {
        return ( <LoadingPanel isLoading={true} />)
    }

    const renderIdNameByScreenAndDevice = ()=>{
        let idName = "parentCo"
        if(isIframeChatBot){ // in iframe desktop screen, don't need parentCo
            if(Number(deviceWidth) > POPUlAR_MOBILE_DEVICE_WIDTH) {
                idName = ""
            }
        }
        return idName
    }

    if(isIframeChatBot && !isPublicAccess) {
        return (
            <Fragment>
                {isShowChatBot() && <>
                    {!isShowChatBox && !isModePreview && (
                        <CollapseChatBox
                            setIsShowChatBox={() => {
                                setIsShowChatBox(true);
                                setIsNewUnReaMessage(false);
                            }}
                            chatbotSettings={chatbotSettings}
                            isIframeChatBot={isIframeChatBot ? isIframeChatBot : false}
                            isNewUnReadMessage={isNewUnReadMessage}
                            POPUlAR_MOBILE_DEVICE_WIDTH={POPUlAR_MOBILE_DEVICE_WIDTH}
                            deviceWidth={deviceWidth}
                        />
                    )}
                    <div
                        className={`chat-box ${!isShowChatBox && !isModePreview && 'displayNone'} ${
                            isModePreview
                                ? 'chat-window-root chat-window-preview'
                                : isMaximizedPanel
                                ? 'chat-window-root chat-window-maximized'
                                : 'chat-window-root chat-window-minimized'
                        } ${hasScrollbar() && isShowModalReload && 'chat-window-root chat-box-position'} `}
                        id={renderIdNameByScreenAndDevice()}
                    >
                        <ExpandHeaderChatbox
                            isModePreview={isModePreview}
                            chatbotSettings={chatbotSettings}
                            setIsShowChatBox={setIsShowChatBox}
                            isMaximizedPanel={isMaximizedPanel}
                            setIsMaximizedPanel={setIsMaximizedPanel}
                            isIframeChatBot={isIframeChatBot ? isIframeChatBot : false}
                            setIsShowModalEndChat={setIsShowModalEndChat}
                            isActivateLiveChat={isActivateLiveChat}
                            setIsNewUnReaMessage={setIsNewUnReaMessage}
                        />

                        <div class='ip-restriction-message'>
                            <IPRestrictionMessage />
                        </div>
                    </div>
                 </>}
            </Fragment>
        )
    }

    return (
        <Fragment>
            {isShowChatBot() && <>
                {!isShowChatBox && !isModePreview && (
                    <CollapseChatBox
                        setIsShowChatBox={() => {
                            setIsShowChatBox(true);
                            setIsNewUnReaMessage(false);
                        }}
                        chatbotSettings={chatbotSettings}
                        isIframeChatBot={isIframeChatBot ? isIframeChatBot : false}
                        isNewUnReadMessage={isNewUnReadMessage}
                        POPUlAR_MOBILE_DEVICE_WIDTH={POPUlAR_MOBILE_DEVICE_WIDTH}
                        deviceWidth={deviceWidth}
                    />
                )}
                <div
                    className={`chat-box ${!isShowChatBox && !isModePreview && 'displayNone'} ${
                        isModePreview
                            ? 'chat-window-root chat-window-preview'
                            : isMaximizedPanel
                            ? 'chat-window-root chat-window-maximized'
                            : 'chat-window-root chat-window-minimized'
                    } ${hasScrollbar() && isShowModalReload && 'chat-window-root chat-box-position'} `}
                    id={renderIdNameByScreenAndDevice()}
                >
                    <ExpandHeaderChatbox
                        isModePreview={isModePreview}
                        chatbotSettings={chatbotSettings}
                        setIsShowChatBox={setIsShowChatBox}
                        isMaximizedPanel={isMaximizedPanel}
                        setIsMaximizedPanel={setIsMaximizedPanel}
                        isIframeChatBot={isIframeChatBot ? isIframeChatBot : false}
                        setIsShowModalEndChat={setIsShowModalEndChat}
                        isActivateLiveChat={isActivateLiveChat}
                        setIsNewUnReaMessage={setIsNewUnReaMessage}
                    />
    
                    <ChatBotListMessage
                        messages={messages}
                        chatbotSettings={chatbotSettings}
                        handleClickFormOption={handleClickFormOption}
                        handleClickFieldOption={handleClickFieldOption}
                        listCategories={listCategories}
                        setMessages={setMessages}
                        listTagFieldSelected={listTagFieldSelected}
                        handleClickItemOption={handleClickItemOption}
                        supportThreadIdState={supportThreadIdState}
                        affiliationOrganization={affiliationOrganization}
                        filterPublicKnowledge={filterPublicKnowledge}
                        listSelectedItemOfSession={listSelectedItemOfSession}
                        listTicketIdBeforeFilterTagField={listTicketIdBeforeFilterTagField}
                        setListKnowledgeTicketId={setListKnowledgeTicketId}
                        projectId={affiliationProject}
                        subDomain={props?.subDomain}
                        scrollIntoViewMsg={scrollIntoViewMsg}
                        messageRef={messageRef}
                        isModePreview={isModePreview}
                        setListTagFieldOfSelectedCategory={setListTagFieldOfSelectedCategory}
                        setListTagFieldId={setListTagFieldId}
                        setFilterPublicKnowledge={setFilterPublicKnowledge}
                        setListSelectedItemOfSession={setListSelectedItemOfSession}
                        setListTagFieldSelected={setListTagFieldSelected}
                        handleWhenRenderTagFieldPriority={handleWhenRenderTagFieldPriority}
                        setListTicketIdBeforeFilterTagField={setListTicketIdBeforeFilterTagField}
                        listKnowledgeTicketId={listKnowledgeTicketId}
                        listTagFieldOfSelectedCategory={listTagFieldOfSelectedCategory}
                        projectAlias={projectAlias}
                        API={props?.API}
                        categoryIdSelected={categoryIdSelected}
                        formQASystem={formQASystem}
                        isMaximizedPanel={isMaximizedPanel}
                        setIsShowModalReload={setIsShowModalReload}
                        setIsActivateLiveChat={setIsActivateLiveChat}
                        setSupportTicketId={setSupportTicketId}
                        setFileUploadList={setFileUploadList}
                        fileUploadList={fileUploadList}
                        fileUploading={fileUploading}
                        isShowMsgConnecting={isShowMsgConnecting}
                        sentMessageList={sentMessageList}
                        listAgentData={listAgentData}
                        isIframeChatBot={isIframeChatBot ? isIframeChatBot : false}
                        projectInuseDetail={projectInuseDetail}
                        currentCorporationDetail={currentCorporationDetail}
                        idOfResponseMessage={idOfResponseMessage}
                        setIsEnableBtnSend={setIsEnableBtnSend}
                        isEnableBtnSend={isEnableBtnSend}
                        setQueryGetListKnowledgeBase={setQueryGetListKnowledgeBase}
                        usingAI={usingAI}
                        listTagItemSelected={listTagItemSelected}
                        setIsEnableMsgInput={setIsEnableMsgInput}
                        listTagFieldSkip={listTagFieldSkip}
                        setListTagFieldSkip={setListTagFieldSkip}
                        enableListTicket={enableListTicket}
                    />
    
                    {/* message connecting  */}
                    <MessageConnecting
                        chatbotSettings={chatbotSettings}
                        supportThreadIdState={supportThreadIdState}
                        affiliationOrganization={affiliationOrganization}
                        messages={messages}
                        setMessages={setMessages}
                        isModePreview={isModePreview}
                        isMaximizedPanel={isMaximizedPanel}
                    />
    
                    {/* chatbot input  */}
                    {isActivateLiveChat && !isModePreview ? (
                        <ChatBotLiveChat
                            chatbotSettings={chatbotSettings}
                            listOptionsAutocomplete={listOptionsAutocomplete}
                            onChangeOptionsAutocomplete={onChangeOptionsAutocomplete}
                            selectedOfOptions={selectedOfOptions}
                            setMessages={setMessages}
                            isActivateLiveChat={isActivateLiveChat}
                            supportTicketId={supportTicketId}
                            supportThreadId={supportThreadIdState}
                            affiliationOrganization={affiliationOrganization}
                            setFileUploadList={setFileUploadList}
                            setFileUploading={setFileUploading}
                            setSentMessageList={setSentMessageList}
                            isModePreview={isModePreview}
                            API={API}
                        />
                    ) : (
                        <ChatBotInput
                            isModePreview={isModePreview}
                            listOptionsAutocomplete={listOptionsAutocomplete}
                            onChangeOptionsAutocomplete={onChangeOptionsAutocomplete}
                            setMessages={setMessages}
                            onSubmitSendMessage={onSubmitSendMessage}
                            usingAI={usingAI}
                            isEnableBtnSend={isEnableBtnSend}
                            messages={messages}
                            chatbotSettings={chatbotSettings}
                            setIsEnableMsgInput={setIsEnableMsgInput}
                            isEnableMsgInput={isEnableMsgInput}
                            listTagFieldOfSelectedCategory={listTagFieldOfSelectedCategory}
                            setListTagFieldOfSelectedCategory={setListTagFieldOfSelectedCategory}
                        />
                    )}
    
                    <ConfirmDialog
                        isOpen={isShowModalReload && !isModePreview}
                        msgConfirm={I18n.get('COMMSG030')}
                        okCallBack={() => window.location.reload()}
                    />
    
                    <ConfirmDialog
                        isOpen={isShowModalEndChat}
                        msgConfirm={I18n.get('CBOTMSG017')}
                        okCallBack={callUpdatedEndChat}
                        closeCallBack={() => setIsShowModalEndChat(false)}
                        textSubmit={I18n.get('COMBTN002')}
                        textClose={I18n.get('COMBTN007')}
                    />
                </div>
            </>}
        </Fragment>
    );
}

export default ChatBox;
